module.exports = __webpack_public_path__ + "img/Forms-pana.47eb498e.svg";